import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = {
  key: 0,
  class: "p-col-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = {
  key: 0,
  class: "p-col-6"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Tons for each Activity ")
const _hoisted_7 = {
  key: 1,
  class: "p-col-6"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Hours for each Activity ")
const _hoisted_9 = {
  key: 2,
  class: "p-col-6"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Cycles for each Activity ")
const _hoisted_11 = {
  key: 3,
  class: "p-col-6"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Budget for each Activity ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData, (data, key) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
          (data.target)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_Card, null, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.capitalizeFirstLetter(key)) + ": " + _toDisplayString(data.total) + " of " + _toDisplayString(data.target) + " : " + _toDisplayString(_ctx.percentValue(key)) + "%", 1),
                    _hoisted_3,
                    _createTextVNode(" Expected to Date: " + _toDisplayString(data.expectedToday) + " : " + _toDisplayString(_ctx.percentExpectedToday(key)) + "% ", 1)
                  ]),
                  content: _withCtx(() => [
                    (data.data)
                      ? (_openBlock(), _createBlock(_component_Chart, {
                          key: 0,
                          type: "bar",
                          data: data.data,
                          options: _ctx.chartOptions,
                          class: "w-full md:w-30rem"
                        }, null, 8, ["data", "options"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ], 512), [
      [_vShow, !_ctx.isLoading]
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.tonsData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_6
              ]),
              content: _withCtx(() => [
                (_ctx.tonsData.datasets[0].data.length)
                  ? (_openBlock(), _createBlock(_component_Chart, {
                      key: 0,
                      type: "bar",
                      options: _ctx.stackedOptions,
                      data: _ctx.tonsData
                    }, null, 8, ["options", "data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.hoursData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_8
              ]),
              content: _withCtx(() => [
                (_ctx.hoursData.datasets[0].data.length)
                  ? (_openBlock(), _createBlock(_component_Chart, {
                      key: 0,
                      type: "bar",
                      options: _ctx.stackedOptions,
                      data: _ctx.hoursData
                    }, null, 8, ["options", "data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.cyclesData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_10
              ]),
              content: _withCtx(() => [
                (_ctx.cyclesData.datasets[0].data.length)
                  ? (_openBlock(), _createBlock(_component_Chart, {
                      key: 0,
                      type: "bar",
                      options: _ctx.stackedOptions,
                      data: _ctx.cyclesData
                    }, null, 8, ["options", "data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.budgetData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_12
              ]),
              content: _withCtx(() => [
                (_ctx.budgetData.datasets[0].data.length)
                  ? (_openBlock(), _createBlock(_component_Chart, {
                      key: 0,
                      type: "bar",
                      options: _ctx.stackedOptions,
                      data: _ctx.budgetData
                    }, null, 8, ["options", "data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}